// native
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// service
import { ItemsDisplayService } from '../../../core/services/items-display.service';

// models
import { IItemTag, ICollection } from '../../../models';

@Component({
  selector: 'navigation-tag',
  templateUrl: './navigation-tag.component.html',
  styleUrls: ['./navigation-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationTagComponent {
  @Input()
  indent = 0;

  @Input()
  collection: ICollection;

  @Input()
  tag: IItemTag;

  loadingSource = new Subject<boolean>();
  loading$: Observable<boolean>;

  constructor(
    private itemsDisplayService: ItemsDisplayService
  ) {
    this.loading$ = this.loadingSource.asObservable();
  }

  openTagItems(){
    this.itemsDisplayService.itemParams$.next({
      collection_id: this.collection.id,
      tags: this.tag.id.split(',')
    })
  }
}
